<section class="call-notification">
  <div class="call-notification__container">
    <div class="call-notification__title">
      <mat-icon *ngIf="(isWhatsappCall$ | async) === false">phone_callback</mat-icon>
      <mat-icon *ngIf="isWhatsappCall$ | async" [svgIcon]="'whatsapp-oficial'"></mat-icon>
      <h2 class="title">{{ title$ | async }}</h2>
    </div>
    <mat-divider></mat-divider>
    <div class="call-notification__content">
      <div class="call-notification__description">
        <div *ngIf="DIDPrefix">
          <p>{{ 'PREFIX' | translate }} {{ DIDPrefix }}</p>
        </div>
        <div *ngIf="contact">
          <p>{{ 'CONTACT' | translate }}: {{ contact.name | titlecase }}</p>
        </div>
        <div *ngIf="number">
          <p>{{ 'ORIGIN_NUMBER' | translate }} {{ number }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="call-notification__buttons">
    <button
      mat-button
      class="call-notification__cancel"
      [style.backgroundColor]="'#b71c1c'"
      [style.color]="'white'"
      (click)="close()"
    >
      {{ 'REFUSE' | translate }}
    </button>
    <button mat-raised-button class="call-notification__confirm" color="primary" (click)="confirm()">
      {{ 'ACCEPT' | translate }}
    </button>
    <button mat-raised-button class="call-notification__confirm" color="default" (click)="silence()">
      {{ 'SILENCE' | translate }}
    </button>
  </div>
</section>
